/* eslint-disable jira/filename-case */
export const GET_ME_URL = '/gateway/api/me';
